import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'apiUsername' | 'scheduledForDeletionAt'>;
};

export default function ApiUserCell({
  rowData: { apiUsername, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      topLine={apiUsername}
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
    />
  );
}
